import React from 'react';
import { motion } from 'framer-motion';

const artigos = [
  {
    titulo: 'Você sabe diferenciar tristeza e depressão?',
    url: 'https://www.grupofleury.com.br/saudedigital/blog/post?slug=voce-sabe-diferenciar-tristeza-e-depressao',
  },
  {
    titulo: 'Ansiedade: quando é saudável e quando precisa de atenção?',
    url: 'https://www.grupofleury.com.br/saudedigital/blog/post?slug=ansiedade-quando-e-saudavel-e-quando-precisa-de-atencao',
  },
];

export default function Sobre() {
  return (
    <section id="sobre" className="py-5" style={{ backgroundColor: '#f7f8f8' }}>
      <div className="container" style={{ maxWidth: '900px' }}>
        <motion.div
          className="bg-white rounded-4 shadow-sm p-4 p-md-5 text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <h2 className="fw-bold mb-3 text-marrom-suave">
            Quem sou eu
          </h2>

          {/* LINHA DECORATIVA */}
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: '80px' }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            style={{
              height: '3px',
              backgroundColor: '#c47a5f',
              margin: '0 auto 25px',
              borderRadius: '2px',
            }}
          />

          <div
            style={{
              fontSize: '1.05rem',
              lineHeight: '1.8',
              color: '#3d4a4d',
              textAlign: 'left',
            }}
          >
            <p className="mb-4">
              Sou Elaine Rampazzo, psicóloga clínica e organizacional, com mais de 15 anos de
              experiência em psicoterapia e desenvolvimento humano.
            </p>

            <p className="mb-4">
              Minha trajetória na Psicologia me permitiu atuar com pessoas em diferentes momentos
              da vida. Durante a minha carreira, desenvolvi experiência em temas como ansiedade, depressão,
              relacionamentos, maternidade e paternidade, autoconhecimento, autoestima,
              adolescência, carreira e desenvolvimento de liderança.
            </p>

            <p className="mb-4">
              Sou mãe de dois filhos, uma experiência que transformou minha vida e ampliou meu
              olhar sobre as relações, a maternidade e os diferentes desafios da vida familiar.
            </p>

            <p className="mb-4">
              Acredito na terapia como um espaço de escuta, reflexão e desenvolvimento, no qual
              cada pessoa pode compreender melhor o que está vivendo, ampliar sua percepção sobre
              si e encontrar novas formas de lidar com suas escolhas e desafios.
            </p>

            <p className="mt-4 fw-semibold" style={{ color: '#1f4e5a' }}>
              Confira alguns dos meus artigos sobre saúde emocional:
            </p>

            <div className="d-flex flex-column align-items-start gap-2">
              {artigos.map((artigo) => (
                <a
                  key={artigo.url}
                  href={artigo.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#1f6f66',
                    fontWeight: '600',
                    textDecoration: 'none',
                  }}
                >
                  {artigo.titulo}
                </a>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
